module.exports = __webpack_public_path__ + "static/media/icon-detailed-records.53960acd.svg";